import { jsx as _jsx } from "react/jsx-runtime";
import { isAndroid, isIOS } from 'react-device-detect';
import { InAppBrowserGate } from '../components/InAppBrowserGate';
import { StreamrAppMobileView } from '../components/streamrapp/StreamrAppMobileView';
import { StreamrAppView } from '../components/streamrapp/StreamrAppView';
import { BroadcastStateService } from '../services/broadcaststate/BroadcastStateService';
import { LobbyService } from '../services/lobby/LobbyService';
import { StreamrAppService } from '../services/streamrapp/StreamrAppService';
export function StreamrAppPage() {
    return (_jsx(InAppBrowserGate, { children: _jsx(StreamrAppPageContent, {}) }));
}
function StreamrAppPageContent() {
    const activeBroadcast = BroadcastStateService.getOutput().useActiveBroadcast();
    if (activeBroadcast === undefined) {
        StreamrAppService.getInstance().notifyInitializeBroadcastFromUrl();
        return null;
    }
    LobbyService.getInstance().notifyEnterLobby(activeBroadcast);
    if (isIOS || isAndroid) {
        return _jsx(StreamrAppMobileView, {});
    }
    return _jsx(StreamrAppView, {});
}
